import client from '#src/api/client'

export async function getCurrentGlobalProtectDevices (username) {
  return (await client.get(`/global-protect/${username}/current`)).data
}
